import * as React from 'react';
import { Action, Dispatch } from 'redux';
import { Publication } from '../../types/epub';
import { toOPFBasedPath, getDefaultRendition } from '../../utils/epub';
import { moveToPage } from '../../actions/PageAction';
import SettingPopup from '../common/SettingPopup';

export interface TableOfContentsProps {
  isOpen: boolean;
  publication: Publication;
  targetTab: number;
  dispatch: Dispatch<Action>;
  onClose: () => void;
}

export class TableOfContents extends React.Component<TableOfContentsProps, {}> {
  private handleClick = (href: string) => {
    const { publication, targetTab, dispatch } = this.props;
    const url = toOPFBasedPath(publication, `${publication.resourceDir}/${href}`);
    const page = getDefaultRendition(publication).itemIndices[url];
    if (page !== undefined && page.linear) {
      moveToPage(targetTab, page.linearIndex, dispatch);
    }
  }

  public render() {
    if (!this.props.isOpen) {
      return null;
    }

    const itemStyle = {
      textDecoration: 'underline',
      cursor: 'pointer',
    };

    const list = getDefaultRendition(this.props.publication).toc.map(item => (
      <li
        style={itemStyle}
        key={item.href}
        onClick={() => this.handleClick(item.href)}>{item.title}</li>
    ));

    const ulStyle: React.CSSProperties = {
      width: '400px',
      height: '300px',
      overflow: 'auto',
    };

    return (
      <SettingPopup title="目次" onClose={this.props.onClose}>
        <ul style={ulStyle}>
          {list}
        </ul>
      </SettingPopup>
    );
  }
}
